import React from "react";
import FakeHistogram from "@/components/Fakes/fake-histogram";
import BillFakeCard from "./bill-card-fake";

const BillsFake = () => {
  return (
    <>
      <section className="container my-bills-fake">
        <div className="my-bills-fake--column-1">
          <div className="my-bills-fake--column-1--histogram">
            <div className="skeleton my-bills-fake--column-1--title" />
            <FakeHistogram />
          </div>
          <div className="my-bills-fake--column-1--boxes">
            <BillFakeCard />
            <BillFakeCard />
          </div>
        </div>
      </section>
      <style jsx>{`
        .my-bills-fake {
          display: flex;
          flex-direction: column;
          &--column-1 {  
            &--boxes {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              gap: 1rem;
            }
            &--title {
              width: 20%;
              height: 24px;
            }
            &--histogram {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 1rem;
            }
          }
        }
        @media (min-width: 768px) {
          .my-bills-fake {
            flex-direction: row;
            justify-content: space-between;
            &--column-1 {
              width: 70%;
              &--boxes {
                flex-direction: row;
              }
            }
            &--column-2 {
              padding: 0 2rem;
            }
          }
        }
      `}</style>
    </>
  );
};

export default BillsFake;